import { LocationSearchModeEnum } from '../enums';

export const getRelatedCities = (
	map: string[][],
	cityId: string,
	mode = LocationSearchModeEnum.General
): string[] => {
	if (mode === LocationSearchModeEnum.Auto) {
		mode = map.some(([mainCityId]) => mainCityId === cityId)
			? LocationSearchModeEnum.General
			: LocationSearchModeEnum.Strict
	}

	if (mode === LocationSearchModeEnum.General) {
		const foundCityGroup = map.find(cityGroup => cityGroup.includes(cityId));

		return foundCityGroup ?? [cityId];
	}

	return [cityId];
}
